/** @format */
import { Notification as BaseNotification } from '@mpb-com/feather/components/atoms/notification';
import { NotificationVariant } from '@mpb-com/feather/components/atoms/notification/types';
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import { styles } from './notification.styles';
import { NotificationProps } from './types';

const StyledNotification = styled(BaseNotification)`
    ${styles}
`;

export const Notification: FunctionComponent<NotificationProps> = ({
    title,
    body,
    children,
    ...props
}) => {
    return (
        <StyledNotification
            variant={NotificationVariant.NOTICE}
            hasIcon={false}
            legacy
            {...props}
        >
            <div className="heading">
                {/* eslint-disable-next-line react/jsx-no-leaked-render -- Legacy code: do not use as an example. */}
                {title && <strong>{title}</strong>}
                {/* eslint-disable-next-line react/jsx-no-leaked-render -- Legacy code: do not use as an example. */}
                {title && body && <br />}
                {body}
            </div>
            <div className="action">{children}</div>
        </StyledNotification>
    );
};
